'use strict';

angular.module('shiftTraderApp')
  .service('DayOffLimitStore', ['$log', '$rootScope', 'Session', 'TimeService', 'DayOffLimits', '$q', '$timeout',
    function ($log, $rootScope, Session, TimeService, DayOffLimits, $q, $timeout) {
      var records = [];
      var cacheAgeByDate = {};
      var maxCacheAgeInSeconds = 10;
      var cacheAgeKeyFormat = 'MM-DD-YYYY';

      var batches = [];

      var dataRequests = [];

      var that = this;

      function createBatch(request) {
        var newBatch = {
          open: true,
          startTime: request.startTime,
          endTime: request.endTime,
          requests: [request],
          timeout: $timeout(function() {
            processBatch(newBatch);
          }, 50)
        };
        batches.push(newBatch);

        return newBatch
      }

      function createDataRequest(startTime, endTime, callback) {
        var request = {
          startTime: startTime,
          endTime: endTime,
          callback: callback
        };

        if (endTime.isAfter(TimeService.getNowInStoreTime())) {
          // only allow adding an exception a year in advance
          request.endTime = moment(TimeService.getBeginningOfDayFromDate(TimeService.getNowInStoreTime())).add(370, 'days');
        }
        dataRequests.push(request);

        return request;
      }

      function createOrAddRequestToBatch(request) {
        // check to see if there are any batches that:
        // open = true OR there is any overlap between request startTime/endTime and batch startTime/endTime

        var matchingBatch = _.find(batches, function(batch) {
          var twx = batch.startTime.twix(batch.endTime);
          var reqTwix = request.startTime.twix(request.endTime);
          return batch.open &&
            ((reqTwix.overlaps(twx) && Math.abs(reqTwix.intersection(twx).length('minutes')) > 0)
            || batch.startTime.isSame(request.endTime, 'minute') || batch.endTime.isSame(request.startTime, 'minute'));
        });

        if (matchingBatch) {
          //console.log('BATCH: FOUND a matching batch', matchingBatch);
          $timeout.cancel(matchingBatch.timeout);
          var twx = matchingBatch.startTime.twix(matchingBatch.endTime);
          var reqTwix = request.startTime.twix(request.endTime);
          var union = twx.union(reqTwix);

          matchingBatch.startTime = union.start;
          matchingBatch.endTime = union.end;
          //console.log('BATCH: new batch times: ', matchingBatch.startTime.format(), matchingBatch.endTime.format());

          matchingBatch.requests.push(request);
          matchingBatch.timeout = $timeout(function() {
            processBatch(matchingBatch);
          }, 50);

        } else {
          var z = createBatch(request);
          //console.log('BATCH: CREATED NEW', z);
        }
      }


      function processBatch(batch) {
        batch.open = false;


        var startDate = TimeService.getBeginningOfDayFromDate(batch.startTime);

        // go to the end of the following day, just to make sure we include everything with dayStartHour
        var endDate = TimeService.getBeginningOfDayFromDate(batch.endTime).add(1, 'days');


        var data = {
          start_date: startDate.toISOString(),
          end_date: endDate.toISOString(),
          organization_id: Session.getCurrentOrgId()
        };

        DayOffLimits.getAll(data)
          .then(function(records) {
            that.updateCache(startDate, endDate, records);

            _.each(batch.requests, function(request) {
              request.callback(request.startTime, request.endTime);
            });

          }, function() {
            request.callback(undefined);
          });
      }


      var that = this;


      this.flush = function() {
        records = [];
        batches = [];
        dataRequests = [];
        cacheAgeByDate = {};
      };

      $rootScope.$on('flushCaches', function() {
        that.flush();
      });

      function canUseCacheForRange(startDate, endDate) {
        // returns simple true or false;
        // IF cache can be used then return true, otherwise return false

        var currDate = moment(startDate);
        var localEndDate = moment(endDate);
        var acceptablePreviousTime = moment.utc().subtract(maxCacheAgeInSeconds, 'seconds');

        //console.log('canUseCacheForRange', currDate.format(), acceptablePreviousTime.format());

        while (currDate.isBefore(localEndDate)) {
          var val = cacheAgeByDate[currDate.format(cacheAgeKeyFormat)];
          if (!val || (val.isBefore && val.isBefore(acceptablePreviousTime))) {
            //console.log('cache insufficient', val, val && val.twix && val.twix(acceptablePreviousTime).length('seconds'), ' seconds');

            return false;
          }

          currDate.add(1, 'days');
          //console.log('currDate is now: ', currDate.format());
        }

        return true;
      }

      this.getRecordsBetweenFromCache = function(startTime, endTime) {
        //console.log('getRecordsBetweenFromCache', startTime.format(), endTime.format(), records.length);
        var range_twix = moment(startTime).twix(moment(endTime));

        return _.where(records, function(record) {
          //console.log('in getRecordsBetweenFromCache', record.id);
          if (record.$isException()) {
            // this IS for a specific date

            //console.log(record.target_date.format(), record.target_date.isSame(startTime, 'day'), record.target_date.isSame(endTime, 'day'), range_twix.contains(record.target_date));

            // get records for same date
            return record.target_date.isSame(startTime, 'day') || record.target_date.isSame(endTime, 'day') ||
              (range_twix.contains(record.target_date));
          } else {
            // this is NOT for a specific date

            // if the record has no ineffective date, then you just have to check that the effective date is less than or equal to the endTime

            //console.log(record.effective_date.format(), record.ineffective_date && record.ineffective_date.format());
            //console.log(record.effective_date.isSame(endTime, 'day'), record.effective_date.isBefore(endTime));

            return (_.isNull(record.ineffective_date) && (record.effective_date.isSame(endTime, 'day') || record.effective_date.isBefore(endTime))) ||
              (!_.isNull(record.ineffective_date) && (record.ineffective_date.isAfter(startTime) || record.ineffective_date.isSame(startTime, 'day')));
          }
        });
      };

      this.addOrReplaceRecord = function(record) {
        var idx = _.findIndex(records, {id: record.id});

        if (idx > -1) {
          records[idx] = record;
        } else {
          records.push(record);
        }
      };

      this.addOrReplaceRecords = function(records) {
        _.each(records, that.addOrReplaceRecord);
      };

      this.updateCache = function(startDate, endDate, records) {
        //console.log('updateRecords!', startDate.format(), endDate.format());
        var currDate = moment(startDate);
        var newTime = moment.utc();
        while (currDate.isBefore(endDate)) {
          cacheAgeByDate[currDate.format(cacheAgeKeyFormat)] = newTime.clone();

          currDate.add(1, 'days');
          //console.log('currDate is now: ', currDate.format());
        }

        //console.log(cacheAgeByDate);
        that.addOrReplaceRecords(records);
        return true;
      };

      this.getLimitsBetween = function(startTime, endTime, forceRequest) {
        console.log('getLimitsBetween', startTime.format(), endTime.format());

        var startDate = TimeService.getBeginningOfDayFromDate(startTime);

        // go to the end of the following day, just to make sure we include everything with dayStartHour
        var endDate = TimeService.getBeginningOfDayFromDate(endTime);

        var canUseCache = !forceRequest && canUseCacheForRange(startDate, endDate);
        //console.log('startDate: ', startDate.format(), 'endDate: ', endDate.format(), ' -- what about that cache?', canUseCache);

        var deferred = $q.defer();

        if (canUseCache) {
          $timeout(function() {
            var x = that.getRecordsBetweenFromCache(startDate, endDate);
            deferred.resolve(x);
          }, 0);
        } else {

          var callback = function(startDt, endDt, records) {
            if (startDate) {
              deferred.resolve(that.getRecordsBetweenFromCache(startDate, endDate));
            } else {
              deferred.reject();
            }
          };

          createOrAddRequestToBatch(createDataRequest(startDate, endDate, callback));
        }
        return deferred.promise;
      };

      this.getLimitForDate = function(dt) {
        var deferred = $q.defer();

        // artifically put back the start when getting just one day so that we can hope to nip a few requests in the bud
        var earlierStart = moment(dt).subtract(30, 'days');
        var dtCopy = moment(dt);

        that.getLimitsBetween(earlierStart, dtCopy)
          .then(function(records) {
            var dtRecords = _.where(records, function(record) {
              return record.$isInEffect(dtCopy);
            });

            if (dtRecords.length === 1) {
              deferred.resolve(dtRecords[0]);
            } else if (dtRecords.length > 1) {
              var r = _.find(dtRecords, function(x) {
                return x.$isException();
              });

              if (r) {
                deferred.resolve(r);
              } else {
                // this should never happen...
                // just in case there are ever two non-exception records, use the most recently created one
                deferred.resolve(_.last(_.sortBy(dtRecords, '_created_at_unix')));
              }
            } else {
              deferred.resolve(null);
            }
          }, function() {
            deferred.reject(undefined);
          });

        return deferred.promise;
      };

      this.getGeneralLimitForDate = function(dt) {
        var deferred = $q.defer();

        // artifically put back the start when getting just one day so that we can hope to nip a few requests in the bud
        var earlierStart = moment(dt).subtract(30, 'days');
        var dtCopy = moment(dt);

        that.getLimitsBetween(earlierStart, dtCopy)
          .then(function(records) {
            var dtRecords = _.where(records, function(record) {
              return record.$isInEffect(dtCopy);
            });

            if (dtRecords.length > 0) {
              deferred.resolve(_.last(_.sortBy(_.where(dtRecords, function(limitRecord) {
                return !limitRecord.$isException();
              }), '_created_at_unix')));
            } else {
              deferred.resolve(null);
            }
          }, function() {
            deferred.reject(undefined);
          });

        return deferred.promise;
      };

      this.getRecordById = function(recordId) {
        return _.find(records, {id: recordId});
      };

      this.removeRecordById = function(recordId) {
        var idx = _.findIndex(records, {id: recordId});

        if (idx > -1) {
          records.splice(idx, 1);
        }

        return (idx > -1);
      };
  }]);
